import * as React from 'react'
import { Helmet } from 'react-helmet'
import { withRouter } from 'react-router'
import qs from 'qs'
import _ from 'lodash'

//components
import CatalogLayout from '../../../../components/ui/CatalogLayout/CatalogLayout'
import RewardsModal from '../../../../components/home/RewardsModal/RewardsModal'
import EConciergeModal from '../../../../components/home/EConciergeModal/EConciergeModal'
import Icon from '../../../../components/ui/Icon/Icon'
import SearchMallModal from '../../../../components/home/SearchMallModal/SearchMallModal'
import SearchModal from '../../../../components/home/SearchModal/SearchModal'
import StoreModal from '../../../../components/home/StoreModal/StoreModal'
import * as ExploreApiService from '../../../../services/api/requests/Explore'
import {
  CardContent,
  LogoContainer,
  Logo,
  LogoFiller,
  Title,
  DineLinkButton,
  StyledCatalogList,
  ErrorCard,
  StyledLink,
  StyledShopDineCard,
  VirtualMall,
  ShopLinkButton,
  ZingIconComponent,
  DineUnwind,
  Heading,
  FormContainer,
  SelectMallButton,
  InputContainer,
  Content,
  StyledBanner,
  BannerContent,
  BannerDescription,
  RewardsCatalogDescription,
  RewardsCatalogTitle,
  StyledH3,
} from './MainView.style'

// data
import filterString from '../../../../services/data/filterString'
import { REWARDS_REWARDS_CATALOG } from '../../../../services/data/errorNames.json'
import { DEFAULT_CATEGORY } from '../../../../services/data/rewardsCategory.json'
import { VOUCHERS } from '../../../../services/data/profilePages.json'

// analytics
import {
  setGAPageView,
  setGAEvent,
} from '../../../../services/analytics/google-analytics'

// controllers
import { doGetAllMalls } from '../../../../controllers/Malls'
import {
  doGetAllRewards,
  doGetAllRewardsMerchants,
  doGetRewardsByMerchant,
  doGetRewardsMerchants,
} from '../../../../controllers/Offers'
import {
  doGetEngangementTypes,
  doGetContentTypeEConcierge,
  doGetExploreShops,
  doGetExploreDine,
  doGetExploreUnwind,
} from '../../../../controllers/Explore'

const ENGAGEMENT_TYPE = doGetEngangementTypes()
const ECONCIERGE = doGetContentTypeEConcierge()

class MainView extends React.Component {
  debouncedSearch = _.debounce(search => {
    setGAEvent('rewards_merchant', 'search_merchant_rewards', search)
  }, 250)

  constructor(props) {
    super(props)

    const { location } = props.history

    const initialSearch = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    })

    this.state = {
      apiKey: '',
      merchants: [],
      shopMerchants: [],
      dineMerchants: [],
      unwindMerchants: [],
      searchQuery: initialSearch.q || '',
      searched: [],
      selectedCatalog: {
        id: DEFAULT_CATEGORY,
      },
      modalToggle: false,
      modalTitle: '',
      searchMallModalState: false,
      searchModalState: false,
      malls: [],
      mallList: [],
      prevSelectedMall: null,
      openSelectMall: false,
      showMerchantModal: false,
      merchantModalData: [],
    }

    this.getRewardsMerchants(DEFAULT_CATEGORY)
    this.getShopMerchants()
    this.getDineMerchants()
    this.getUnwindMerchants()

    doGetAllMalls({
      onSuccess: ({ data }) => {
        this.setState({
          malls: data,
          mallList: data.map(mall => ({
            name: mall.name,
            value: mall.slugName,
          })),
        })
      },
    })
  }

  componentWillMount() {
    this.retrieveInitialData()
  }

  componentDidMount() {
    const { location } = this.props
    setGAPageView(location.pathname)
  }

  componentDidUpdate(prevProps) {
    const { match, location } = this.props
    const { viewType, viewId } = match.params
    const {
      viewType: prevViewType,
      viewId: prevViewId,
    } = prevProps.match.params

    if (viewType !== prevViewType || viewId !== prevViewId) {
      this.displayModal()
    }

    if (location.pathname !== prevProps.location.pathname) {
      setGAPageView(location.pathname)
    }
  }

  getShopMerchants = (mallSlugName = null) => {
    const { selectedMallSlug, accessToken } = this.props
    doGetExploreShops({
      accessToken,
      collectionType: ECONCIERGE,
      onSuccess: ({ data }) => {
        this.setState({ shopMerchants: data })
      },
    })('', mallSlugName ? mallSlugName : selectedMallSlug)
  }

  getDineMerchants = (mallSlugName = null) => {
    const { selectedMallSlug, accessToken } = this.props
    doGetExploreDine({
      accessToken,
      collectionType: ECONCIERGE,
      onSuccess: ({ data }) => {
        this.setState({ dineMerchants: data })
      },
    })('', mallSlugName ? mallSlugName : selectedMallSlug)
  }

  getUnwindMerchants = (mallSlugName = null) => {
    const { selectedMallSlug, accessToken } = this.props
    doGetExploreUnwind({
      accessToken,
      collectionType: ECONCIERGE,
      onSuccess: ({ data }) => {
        this.setState({ unwindMerchants: data })
      },
    })('', mallSlugName ? mallSlugName : selectedMallSlug)
  }

  getRewardsMerchants = async (id = 0) => {
    const {
      accessToken,
      history,
      errorList,
      setError,
      removeError,
    } = this.props

    if (errorList.length) {
      removeError(REWARDS_REWARDS_CATALOG)
    }

    const search = qs.parse(history.location.search, {
      ignoreQueryPrefix: true,
    })

    const pageLoadStart = Date.now()

    if (id === 0) {
      await doGetAllRewardsMerchants({
        accessToken,
        onSuccess: ({ data }) => {
          this.setState({
            merchants: data.sort((a, b) =>
              a.name > b.name ? 1 : a.name < b.name ? -1 : 0,
            ),
            searched: search.q
              ? data.filter(merchant =>
                  merchant.name.toLowerCase().includes(search.q.toLowerCase()),
                )
              : [],
          })
          setGAEvent(
            'page',
            'loading_duration',
            'rewards_catalog',
            Date.now() - pageLoadStart,
          )
        },
        onError: error => {
          setError({
            name: REWARDS_REWARDS_CATALOG,
            error: error.message,
          })
        },
      })
    } else {
      doGetRewardsMerchants({
        accessToken,
        onSuccess: ({ data }) => {
          this.setState({
            merchants: data.sort((a, b) =>
              a.name > b.name ? 1 : a.name < b.name ? -1 : 0,
            ),
            searched: search.q
              ? data.filter(merchant =>
                  merchant.name.toLowerCase().includes(search.q.toLowerCase()),
                )
              : [],
          })
          setGAEvent(
            'page',
            'loading_duration',
            'rewards_catalog',
            Date.now() - pageLoadStart,
          )
        },
        onError: error => {
          setError({
            name: REWARDS_REWARDS_CATALOG,
            error: error.message,
          })
        },
      })('', id)
    }
  }

  onCategoriesChange = e => {
    const catalogId = e.target.value
    const { setRewards, accessToken } = this.props

    doGetAllRewards({ accessToken, setRewards })('', catalogId)
  }

  retrieveInitialData = async () => {
    const { waitRenderServer, renderServer } = this.props

    waitRenderServer(true)

    await this.displayModal()

    renderServer()
  }

  displayModal = async () => {
    const {
      match,
      setRewardModalData,
      setRewardModalStatus,
      accessToken,
      // advanceAccount,
    } = this.props
    const { viewId } = match.params

    if (viewId) {
      setRewardModalStatus(1)
      try {
        await doGetRewardsByMerchant({ accessToken, setRewardModalData })(
          viewId,
        )
        setRewardModalStatus(0)
      } catch (e) {
        setRewardModalStatus(4)
      }
    } else {
      setRewardModalData({})
      setRewardModalStatus(null)

      setGAEvent('page', 'page_visit', 'rewards_catalog')
    }
  }

  handleClose = () => {
    const {
      push,
      baseUrl,
      setRewardModalData,
      setRewardModalStatus,
    } = this.props

    if (push) {
      push(`${baseUrl}`)
      setRewardModalData({})
      setRewardModalStatus(null)
    }
  }

  onCatalogChange = catalog => {
    this.setState({
      merchants: [],
    })
    this.getRewardsMerchants(catalog.id)

    setGAEvent('rewards', 'rewards_category', catalog.name)
  }

  onCatalogSearch = e => {
    const { merchants } = this.state

    const searched = merchants.filter(merchant => {
      const merchantName = merchant.name.toLowerCase()
      const searchQuery = e.target.value.toLowerCase()

      return merchantName.includes(searchQuery)
    })

    this.setState({
      searchQuery: e.target.value,
      searched,
    })

    this.debouncedSearch(e.target.value)
  }

  displayMyVouchers = data => {
    const {
      displayProfileModal,
      setProfileModalPage,
      setProfileModalDetailPage,
      accessToken,
    } = this.props

    if (accessToken) {
      displayProfileModal(true)
      setProfileModalPage(VOUCHERS)
      if (data) {
        setProfileModalDetailPage(data)
      }
    }
  }

  handleModal = (state, title = '') => {
    this.setState({
      modalToggle: state,
      modalTitle: title,
    })
  }

  handleShowExploreSearch = e => {
    e.stopPropagation()
    this.setState({
      searchModalState: true,
    })
  }

  searchMallModalToggle = e => {
    this.setState({
      searchMallModalState: false,
    })
  }

  searchModalToggle = e => {
    this.setState({
      searchModalState: false,
    })
  }

  handleSelectMall = e => {
    e.stopPropagation()
    this.setState({
      searchMallModalState: true,
    })
  }

  handleMerchantModal = itemId => {
    ExploreApiService.getStore(itemId).then(response => {
      this.setState({
        showMerchantModal: true,
        merchantModalData: response.data,
      })
    })
  }

  handleMerchantModalClose = e => {
    this.setState({ showMerchantModal: false })
  }

  onChangeMall = async mallSlugName => {
    const {
      push,
      // malls,
      // baseUrl,
      // accessToken,
      // showAddFavorite,
      // disableFavoritePrompt,
      // favoriteMalls,
      setSelectedMallSlug,
      // match,
    } = this.props

    // const { viewType, viewId } = match.params

    if (push) {
      this.setState({
        searchMallModalState: false,
      })

      setSelectedMallSlug(mallSlugName)
      this.getShopMerchants(mallSlugName)
      this.getDineMerchants(mallSlugName)
      this.getUnwindMerchants(mallSlugName)
    }
  }

  render() {
    const {
      history,
      showRewardModal,
      rewardModalData,
      rewardModalStatus,
      advanceAccount,
      accessToken,
      push,
      baseUrl,
      setLoyaltyPoints,
      loyaltyPoints,
      setLoyaltyPointsError,
      loyaltyPointsError,
      errorList,
      selectedMallSlug,
      setFavoriteMalls,
      match,
      deviceLocation,
      favoriteMalls,
      setSelectedMallSlug,
      merchantModalStatus,
      // malls,
      ...theProps
    } = this.props

    const {
      // merchants,
      shopMerchants,
      dineMerchants,
      unwindMerchants,
      // searched,
      // searchQuery: searchQueryState,
      // selectedCatalog,
      modalToggle,
      showMerchantModal,
      merchantModalData,
    } = this.state

    const selectedMall = this.state.malls.find(
      mall =>
        mall.slugName === selectedMallSlug && mall.explore && mall.slugName,
    )

    const Banner = () => (
      <StyledBanner>
        <BannerContent>
          <BannerDescription>
            <RewardsCatalogTitle>EConcierge</RewardsCatalogTitle>
            <RewardsCatalogDescription>
              Avoid waiting in lines! Here’s easy access to telephone numbers of
              restaurants for your dine-in reservations, and service merchants
              for your appointments.
            </RewardsCatalogDescription>
          </BannerDescription>
        </BannerContent>
      </StyledBanner>
    )

    return (
      <CatalogLayout
        banner={Banner}
        isEConcierge={true}
        match={match}
        selectedMall={selectedMall}
        accessToken={accessToken}
        {...theProps}
      >
        <Heading>
          <FormContainer>
            <SelectMallButton
              onClick={e => {
                this.handleSelectMall(e)
              }}
            >
              <span>
                {(selectedMall && selectedMall.name) || 'Select Mall'}
              </span>
              <Icon name="caret" />
            </SelectMallButton>

            <InputContainer onClick={this.handleShowExploreSearch}>
              Search Merchant
              <Icon name="search" />
            </InputContainer>
          </FormContainer>
        </Heading>

        <Content>
          {shopMerchants && shopMerchants.length > 0 && (
            <>
              <VirtualMall>
                <h3>Visit Virtual Mall</h3>
                <ShopLinkButton
                  to={`/econcierge/${selectedMallSlug}/view-all/shop/`}
                  onClick={() => {
                    this.handleModal(true, ENGAGEMENT_TYPE.Shop)
                  }}
                >
                  View all
                </ShopLinkButton>
              </VirtualMall>

              <StyledCatalogList
                dataSource={shopMerchants.slice(0, 3)}
                loadingComponent={() => (
                  <ErrorCard>
                    <ZingIconComponent />
                  </ErrorCard>
                )}
                renderItem={(item, index) => (
                  <StyledLink
                    // to={`${viewTypeBaseUrl(item.type, selectedMallSlug)}/${
                    //   item.itemId
                    // }`}
                    onClick={() => {
                      this.handleMerchantModal(item.itemId)
                      setGAEvent('item_clicks', 'view_shop_item', item.title)
                    }}
                  >
                    <StyledShopDineCard cardImageUrl={item.imageUrl}>
                      <CardContent>
                        <LogoContainer cardImageUrl={item.imageUrl}>
                          {item.logoUrl ? (
                            <Logo src={item.logoUrl} />
                          ) : (
                            <LogoFiller>&nbsp;</LogoFiller>
                          )}
                        </LogoContainer>
                        <Title>{item.title}</Title>
                      </CardContent>
                    </StyledShopDineCard>
                  </StyledLink>
                )}
              />
            </>
          )}
          {dineMerchants && dineMerchants.length > 0 && (
            <>
              <DineUnwind>
                <StyledH3>Reserve a Restaurant</StyledH3>
                <DineLinkButton
                  // onClick={() => {
                  //   this.handleModal(true, ENGAGEMENT_TYPE.Dine)
                  // }}
                  to={`/econcierge/${selectedMallSlug}/view-all/dine/`}
                >
                  View all
                </DineLinkButton>
              </DineUnwind>

              <StyledCatalogList
                dataSource={dineMerchants.slice(0, 3)}
                loadingComponent={() => (
                  <ErrorCard>
                    <Title>Failed to load Shop.</Title>
                  </ErrorCard>
                )}
                renderItem={(item, index) => (
                  <StyledLink
                    onClick={() => {
                      this.handleMerchantModal(item.itemId)
                      setGAEvent('item_clicks', 'view_shop_item', item.title)
                    }}
                  >
                    <StyledShopDineCard cardImageUrl={item.imageUrl}>
                      <CardContent>
                        <LogoContainer cardImageUrl={item.imageUrl}>
                          {item.logoUrl ? (
                            <Logo src={item.logoUrl} />
                          ) : (
                            <LogoFiller>&nbsp;</LogoFiller>
                          )}
                        </LogoContainer>
                        <Title>{item.title}</Title>
                      </CardContent>
                    </StyledShopDineCard>
                  </StyledLink>
                )}
              />
            </>
          )}
          {unwindMerchants && unwindMerchants.length > 0 && (
            <>
              <DineUnwind>
                <StyledH3>Book an Appointment</StyledH3>
                <DineLinkButton
                  to={`/econcierge/${selectedMallSlug}/view-all/unwind/`}
                >
                  View all
                </DineLinkButton>
              </DineUnwind>

              <StyledCatalogList
                dataSource={unwindMerchants.slice(0, 3)}
                loadingComponent={() => (
                  <ErrorCard>
                    <Title>Failed to load Shop.</Title>
                  </ErrorCard>
                )}
                renderItem={(item, index) => (
                  <StyledLink
                    onClick={() => {
                      this.handleMerchantModal(item.itemId)
                      setGAEvent('item_clicks', 'view_shop_item', item.title)
                    }}
                  >
                    <StyledShopDineCard cardImageUrl={item.imageUrl}>
                      <CardContent>
                        <LogoContainer cardImageUrl={item.imageUrl}>
                          {item.logoUrl ? (
                            <Logo src={item.logoUrl} />
                          ) : (
                            <LogoFiller>&nbsp;</LogoFiller>
                          )}
                        </LogoContainer>
                        <Title>{item.title}</Title>
                      </CardContent>
                    </StyledShopDineCard>
                  </StyledLink>
                )}
              />
            </>
          )}
        </Content>

        <RewardsModal
          show={showRewardModal}
          onClose={this.handleClose}
          data={rewardModalData}
          advanceAccount={advanceAccount}
          accessToken={accessToken}
          onLinkCard={this.displayAddCardForm}
          setLoyaltyPoints={setLoyaltyPoints}
          loyaltyPoints={loyaltyPoints}
          loading={rewardModalStatus}
          loyaltyPointsError={loyaltyPointsError}
          setLoyaltyPointsError={setLoyaltyPointsError}
          displayMyVoucher={this.displayMyVouchers}
        />
        {showRewardModal && rewardModalData.length && (
          <Helmet defaultTitle={rewardModalData[0].merchantName}>
            <meta
              property="og:title"
              content={rewardModalData[0].merchantName}
            />
            <meta
              property="og:description"
              content={filterString(rewardModalData[0].body)}
            />
            <meta property="og:image" content={rewardModalData[0].imageUrl} />
            <meta property="og:type" content="website" />
          </Helmet>
        )}

        {modalToggle && (
          <EConciergeModal
            modalTitle={this.state.modalTitle}
            onClose={this.handleModal}
            malls={this.state.malls}
            mallList={this.state.mallList}
            selectedMallSlug={selectedMallSlug}
            setSelectedMallSlug={setSelectedMallSlug}
          />
        )}

        <SearchMallModal
          modalState={this.state.searchMallModalState}
          onClose={this.searchMallModalToggle}
          malls={this.state.malls}
          push={push}
          match={match}
          accessToken={accessToken}
          setFavoriteMalls={setFavoriteMalls}
          baseUrl={baseUrl}
          currentMall={selectedMallSlug}
          onChangeMall={this.onChangeMall}
          selectedMall={selectedMall && selectedMall.id}
          deviceLocation={deviceLocation}
          displayClose={selectedMallSlug !== ''}
          favoriteMalls={favoriteMalls}
          setSelectedMallSlug={setSelectedMallSlug}
        />

        {this.state.searchModalState && (
          <SearchModal
            altTitle={'Econcierge'}
            onCloseSelectMall={this.handleCloseSelectMall}
            onClose={this.searchModalToggle}
            onCloseMerchant={this.handleMerchantModalClose}
            onSelectMerchant={this.handleMerchantModal}
            initialMall={selectedMall}
            malls={this.state.malls}
            mallList={this.state.mallList}
            push={push}
            match={match}
            contentType={1}
            accessToken={accessToken}
            favoriteMalls={favoriteMalls}
            deviceLocation={deviceLocation}
            setFavoriteMalls={setFavoriteMalls}
            isEconcierge={true}
          />
        )}
        <StoreModal
          malls={this.state.malls}
          show={showMerchantModal}
          data={merchantModalData}
          loading={merchantModalStatus}
          onClose={this.handleMerchantModalClose}
        />
      </CatalogLayout>
    )
  }
}

MainView.defaultProps = {
  // TODO: specify default props
}

MainView.propTypes = {
  // TODO: specify prop types
}

export default withRouter(MainView)
